import i18n from "i18next";
import type { FC } from "react";
import { useCallback } from "react";

import type { Entity } from "../../core/types/fe/Entity";
import { SecondaryButton } from "../Buttons/components/ActionButton";

type CopyButtonProps = {
    isDisabled: boolean;
    onClick?: (itemToCopy: object) => void;
    itemToCopy: Entity;
};

export const FormCopyButton: FC<CopyButtonProps> = ({ isDisabled, onClick, itemToCopy }) => {
    const callback = useCallback(() => {
        if (onClick) {
            onClick(itemToCopy);
        }
    }, [onClick, itemToCopy]);

    return (
        <SecondaryButton name="FormCopyButton" disabled={isDisabled} onClick={callback}>
            {i18n.t("button.copy")}
        </SecondaryButton>
    );
};
